import React from 'react';
import { useTranslation } from 'react-i18next';

function QuoteBanner() {
    const [t] = useTranslation('quote');

    return (
        <div className={'w-full max-w-screen-xl'}>
            <div className={'flex w-full'}>
                <div className={'mr-4 text-4xl text-indotech-primary_blue sm:text-5xl'}>{t('title.first')}</div>
                <div className={'text-4xl text-indotech-orange sm:text-5xl'}>{t('title.second')}</div>
            </div>

            <div className={'mt-6 text-3xl text-indotech-primary_blue'}>{t('subtitle')}</div>
        </div>
    );
}

export default QuoteBanner;
